import "./LoadingOverlay.css";

const LoadingOverlay = ({ message = "Lade Termine" }) => {
  return (
    <div className="loading-overlay">
      <div className="spinner" />
      <p>{message}</p>
    </div>
  );
};

export default LoadingOverlay;

